import { ApiService } from 'services';

import { handleException } from 'actions/exceptions';

export const GET_CUSTOMERS_REQUEST = 'GET_CUSTOMERS_REQUEST';
export const GET_CUSTOMERS_SUCCESS = 'GET_CUSTOMERS_SUCCESS';
export const GET_CUSTOMERS_FAILURE = 'GET_CUSTOMERS_FAILURE';

function requestGetCustomers() {
  return {
    type: GET_CUSTOMERS_REQUEST,
    isGettingCustomers: true
  };
}

function receiveGetCustomers(customers, customersCount) {
  return {
    type: GET_CUSTOMERS_SUCCESS,
    isGettingCustomers: false,
    customers,
    customersCount
  };
}

function rejectGetCustomers() {
  return {
    type: GET_CUSTOMERS_FAILURE,
    isGettingCustomers: false
  };
}

export function getCustomers(pageNumber, pageSize, sortByField, sortDirection, filterList, searchQuery, legalEntity, legalEntitySelected, accountNumberSelected, accountNumber, customer, customerSelected) {
  return (dispatch) => {
    dispatch(requestGetCustomers());
    const promise = () => ApiService
      .getCustomers(pageNumber, pageSize, sortByField, sortDirection, filterList, searchQuery, legalEntity, legalEntitySelected, accountNumberSelected, accountNumber, customer, customerSelected)
      .then((response) => {
        dispatch(receiveGetCustomers(response.data.items, response.data.totalCount));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectGetCustomers, true));
        }
      });
    return promise();
  };
}

export function getCustomersByObject(requestObject) {
  return getCustomers(
    requestObject.pageNumber,
    requestObject.pageSize,
    requestObject.sortByField,
    requestObject.sortDirection,
    requestObject.filterList,
    requestObject.searchQuery,
    requestObject.legalEntity,
    requestObject.legalEntitySelected,
    requestObject.accountNumberSelected,
    requestObject.accountNumber,
    requestObject.customer,
    requestObject.customerSelected
  );
}
